import { render, staticRenderFns } from "./reporters-detail.component.html?vue&type=template&id=6297b006&scoped=true&"
import script from "./reporters-detail.component.ts?vue&type=script&lang=ts&"
export * from "./reporters-detail.component.ts?vue&type=script&lang=ts&"
import style0 from "./reporters-detail.component.scss?vue&type=style&index=0&id=6297b006&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6297b006",
  null
  
)

export default component.exports